// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__HAGOb","emails":"CreateEditClinics_emails__UvUuo","emailTagLabel":"CreateEditClinics_emailTagLabel__3BExq"};